import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { SearchIcon } from "lucide-react";
import { Container } from "@/components/container";
import { EpisodeEntry } from "@/components/episode-entry";
import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from "@/components/ui/empty";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/$podcast/")({
	component: RouteComponent,
	loader: async ({ context, params }) => {
		if (!context.podcast) {
			throw notFound();
		}

		// Prefetch the episodes for the podcast to improve perceived performance
		context.queryClient.prefetchQuery(
			orpc.channels.listEpisodes.queryOptions({
				input: { slug: params.podcast },
			}),
		);

		return {
			podcast: context.podcast,
		};
	},
});

function RouteComponent() {
	const params = Route.useParams();
	const { podcast } = Route.useLoaderData();

	const { data: episodes } = useSuspenseQuery(
		orpc.channels.listEpisodes.queryOptions({
			input: { slug: params.podcast },
		}),
	);

	return (
		<div className="pt-16 pb-12 sm:pb-4 lg:pt-12">
			<Container>
				<h1 className="text-2xl/7 font-bold text-slate-900">Episodes</h1>
			</Container>
			<div className="divide-y divide-slate-100 sm:mt-4 lg:mt-8 lg:border-t lg:border-slate-100">
				{episodes.map((episode) => (
					<EpisodeEntry key={episode.ID} episode={episode} podcast={podcast} />
				))}
				{episodes.length === 0 && (
					<Empty className="w-full">
						<EmptyHeader>
							<EmptyMedia variant="icon">
								<SearchIcon />
							</EmptyMedia>
							<EmptyTitle>No episodes found</EmptyTitle>
							<EmptyDescription>This podcast does not have any episodes yet.</EmptyDescription>
						</EmptyHeader>
					</Empty>
				)}
			</div>
		</div>
	);
}
